import { render, staticRenderFns } from "./registration-error.vue?vue&type=template&id=6a8e87e7&scoped=true"
import script from "./registration-error.vue?vue&type=script&lang=js"
export * from "./registration-error.vue?vue&type=script&lang=js"
import style0 from "./registration-error.vue?vue&type=style&index=0&id=6a8e87e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e87e7",
  null
  
)

export default component.exports